import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "advance-replacement-customer",
  value: "Advance_Replacement_To_Customer",
  labelKey: "inventory.transferAdvanceReplacementToCustomer",
  party: "customer",
};

export function AdvanceReplacementToCustomerModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
